import React, {useCallback, useEffect, useState} from 'react';
import {RESOURCES as resources} from '../../resourcesUser';
import {makeGetDataRequest} from '../../utils/getRequest';
import Config from '../../config';

/**
 * Project Configuration Fields and Inputs
 *
 * @param viewType
 * @param project
 * @param config
 * @param ownProject
 * @param onConfigUpdated
 * @returns {JSX.Element}
 * @constructor
 */
const ProjectConfigFields = ({viewType, project, config, ownProject, onConfigUpdated}) => {
    const [global, setGlobal] = useState({
        max_dataset_size: config?.max_dataset_size ?? Config.projectConfigDefault.max_dataset_size,
        max_shares: config?.max_shares ?? Config.projectConfigDefault.max_shares,
        max_volumes: config?.max_volumes ?? Config.projectConfigDefault.max_volumes
    });
    const [configValues, setConfigValues] = useState({
        max_dataset_size: project?.max_dataset_size ?? global.max_dataset_size,
        max_shares: project?.max_shares ?? global.max_shares,
        max_volumes: project?.max_volumes ?? global.max_volumes
    });

    // Callback: Set Config values with fallback
    const updateConfig = useCallback((userConfig) => {
        let config = {};
        // Set Project value, User value, or global default value
        config.max_dataset_size =
            (project.max_dataset_size !== null)
                ? project.max_dataset_size : (userConfig.max_dataset_size !== null)
                    ? userConfig.max_dataset_size : global.max_dataset_size;
        config.max_shares =
            (project.max_shares !== null)
                ? project.max_shares : (userConfig.max_shares !== null)
                    ? userConfig.max_shares : global.max_shares;
        config.max_volumes =
            (project.max_volumes !== null)
                ? project.max_volumes : (userConfig.max_volumes !== null)
                    ? userConfig.max_volumes : global.max_volumes;
        setConfigValues(config);

        if (typeof onConfigUpdated === 'function') {
            onConfigUpdated(config);
        }
    }, [project, global, onConfigUpdated])

    // Effect: Update Global default Configurations
    useEffect(
        () => {
            const updateGlobalConfig = () => {
                setGlobal({
                    max_dataset_size: config?.max_dataset_size ?? Config.projectConfigDefault.max_dataset_size,
                    max_shares: config?.max_shares ?? Config.projectConfigDefault.max_shares,
                    max_volumes: config?.max_volumes ?? Config.projectConfigDefault.max_volumes
                });
            };

            return updateGlobalConfig();

        }, [config]
    )

    // Effect: Get Configurations from Project's Creator (if any)
    useEffect(() => {
        const params = {
            username: project.username
        };
        const fetchUserData = () => {
            const resource = (ownProject) ? 'User' : 'UserInfo';
            const request = makeGetDataRequest(resources, resource, 'GET_ONE', params);
            request.then(result => {
                if (result) {
                    updateConfig({
                        max_dataset_size: result?.max_dataset_size ?? null,
                        max_shares: result?.max_shares ?? null,
                        max_volumes: result?.max_volumes ?? null
                    });
                    return Promise.resolve(result);
                } else {
                    console.log('User Error: No result');
                    return Promise.reject('Get User failed');
                }
            }).catch(error => {
                console.log('Get User Error: ', error);
                return Promise.reject('Server Error');
            });
        };

        return fetchUserData();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [project.username, ownProject]);

    if (viewType === 'edit') {
        return (
            <>
            </>
        )
    }

    return (
        <div className="row mb-2">
            <span className="col col-xs-6 col-md-4">
                <h4>Max Dataset Size</h4>
                <p className="details">{configValues.max_dataset_size} GB</p>
            </span>
            <span className="col col-xs-6 col-md-4">
                <h4>Max Shares</h4>
                <p className="details">{configValues.max_shares}</p>
            </span>
            <span className="col col-xs-6 col-md-4">
                <h4>Max Volumes</h4>
                <p className="details">{configValues.max_volumes}</p>
            </span>
        </div>
    );
};

export default ProjectConfigFields;
